import { createSlice } from "@reduxjs/toolkit";

import { getAnonymityInfo } from "./client.operations";
import {
  getClientAnonymityInfoFulfilledReducer,
  getPendingReducer,
  getRejectedReducer,
} from "./client.reducer";
import { clientInitialState } from "./clientInitialState";

const clientSlice = createSlice({
  name: "client",
  initialState: clientInitialState,

  extraReducers: builder =>
    builder
      .addCase(getAnonymityInfo.pending, getPendingReducer)
      .addCase(
        getAnonymityInfo.fulfilled,
        getClientAnonymityInfoFulfilledReducer,
      )
      .addCase(getAnonymityInfo.rejected, getRejectedReducer),
});

export const ClientAction = {
  getAnonymityInfo,
};

export default clientSlice.reducer;
